export default __webpack_public_path__ + "static/media/blog-img212.d85c49a9.jpg";